import {
	Component,
	NgZone
} from "@angular/core";
import {
	NavController,
	NavParams,
	App
} from "ionic-angular";

import {
	AddOrderServiceProvider
} from "./../add-order.service";

import {
	APIServiceProvider
} from "./../../../common/services/api.service";
import {
	HelperServiceProvider
} from "./../../../common/services/helper.service";
import {
	NotifyService
} from "../../../services/notify.service";
import {
	HomePage
} from "../../home/home";

@Component({
	selector: "page-customer",
	templateUrl: "customer.html"
})
export class CustomerPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public app: App,
		public addOrderService: AddOrderServiceProvider,
		public apiService: APIServiceProvider,
		private notifyService: NotifyService
	) {}

	saveCustomerBtn = false;
	is_update_action = false;
	is_retailer: any = false;
	ionViewDidLoad() {
		this.addOrderService.reInitializeData();

		this.getStates();

		if (this.addOrderService.external_mobile_number) {
			this.addOrderService.postData.mobile_no = this.addOrderService.external_mobile_number;

			this.getCustomerInfoByMobile(
				this.addOrderService.postData.mobile_no
			);

			this.is_update_action = true;

			this.addOrderService.external_mobile_number = null;
		} else {
			this.is_update_action = false;
		}
	}

	getStates() {
		this.apiService
			.get("state/all", null, null, false)
			.subscribe(result => {
				this.addOrderService.all_state = [];
				this.addOrderService.all_state = result["data"];

				this.addOrderService.m_all_state = [];
				this.addOrderService.m_all_state = result["data"];
			});
	}

	continueCustomerProfile() {
		if (!this.validateData()) {
			return;
		}

		let self = this;

		this.saveCustomerBtn = true;

		this.apiService
			.post("customer/save-customer", this.addOrderService.postData)
			.subscribe(
				response => {
					localStorage.setItem('is_retailer', this.is_retailer)
					this.notifyService.CustomerSaved(true);
					this.addOrderService.postData.customer_id =
						response["data"];

					this.saveCustomerBtn = false;

					this.saveOpportunityData();

					this.zone.run(() => {
						self.addOrderService.disableOtherTabs = true;
					});
				},
				error => {
					this.saveCustomerBtn = false;
				}
			);
	}

	saveUpdatepportunityData() {
		this.apiService
			.post("opportunities/update", this.addOrderService.postData)
			.subscribe(response => {
				this.navCtrl.parent.select(1);
				this.saveCustomerBtn = false;
			});
	}

	saveOpportunityData() {
		this.apiService
			.post("opportunities/add", this.addOrderService.postData)
			.subscribe(response => {
				this.addOrderService.postData.opportunity_id = response["data"];
				this.navCtrl.parent.select(1);
				this.saveCustomerBtn = false;
			});
	}

	getCustomerDatabyMobile() {
		if (String(this.addOrderService.postData.mobile_no).length === 10) {
			this.getCustomerInfoByMobile(
				this.addOrderService.postData.mobile_no
			);
		}
	}

	removeAddress() {
		delete this.addOrderService.postData["state"];
		delete this.addOrderService.postData["district"];
		delete this.addOrderService.postData["tehsil"];
		delete this.addOrderService.postData["village"];
		delete this.addOrderService.postData["pincode"];
		delete this.addOrderService.postData["address_line_1"];
	}

	validateData() {
		let self = this;

		if (
			typeof this.addOrderService.postData.mobile_no === "undefined" ||
			this.addOrderService.postData.mobile_no === "" ||
			this.addOrderService.postData.mobile_no === null
		) {
			this.helperService.presentToast("Please enter mobile number");

			setTimeout(function() {
				self.navCtrl.parent.select(0);
			}, 1000);
			return false;
		}

		if (this.addOrderService.postData.mobile_no.toString().length != 10) {
			this.helperService.presentToast(
				"Please enter 10 digit mobile number"
			);

			setTimeout(function() {
				self.navCtrl.parent.select(0);
			}, 1000);
			return false;
		}

		if (this.addOrderService.postData.alternate_mobile_no) {
			if (this.addOrderService.postData.alternate_mobile_no !== "") {
				if (
					this.addOrderService.postData.alternate_mobile_no.toString()
					.length != 10
				) {
					this.helperService.presentToast(
						"Please enter 10 digit alternate mobile number"
					);

					setTimeout(function() {
						self.navCtrl.parent.select(0);
					}, 1000);

					return false;
				} else {
					let checknumber = parseInt(
						this.addOrderService.postData.alternate_mobile_no
					);

					if (isNaN(checknumber)) {
						this.helperService.presentToast(
							"Please enter 10 digit alternate mobile number"
						);

						setTimeout(function() {
							self.navCtrl.parent.select(0);
						}, 1000);

						return false;
					} else {
						if (checknumber.toString().length != 10) {
							this.helperService.presentToast(
								"Please enter 10 digit alternate mobile number"
							);

							setTimeout(function() {
								self.navCtrl.parent.select(0);
							}, 1000);

							return false;
						}
					}
				}
			}
		}

		if (
			typeof this.addOrderService.postData.first_name === "undefined" ||
			this.addOrderService.postData.first_name === "" ||
			this.addOrderService.postData.first_name === null
		) {
			this.helperService.presentToast("Please enter first name");

			setTimeout(function() {
				self.navCtrl.parent.select(0);
			}, 1000);
			return false;
		} else {
			this.addOrderService.postData.first_name = this.addOrderService.postData.first_name.replace(
				/\s/g,
				""
			);

			if (this.addOrderService.postData.first_name === "") {
				this.helperService.presentToast("Please enter first name");

				setTimeout(function() {
					self.navCtrl.parent.select(0);
				}, 1000);
				return false;
			}
		}

		return true;
	}

	createRetailerLEad() {

		if (!this.validateData()) {
			return;
		}

		this.apiService
			.post(
				"lead/add-retailer-lead", {
					mobile_no: this.addOrderService.postData.mobile_no
				}
			).subscribe(v => {
				this.helperService.presentToast(
					"Successfully Lead Send"
				);

				this.app.getRootNav().setRoot(HomePage);
			})
	}

	getCustomerInfoByMobile(mobile_no) {
		this.apiService
			.post("customer/get-customer-by-phone", {
				mobile_no: mobile_no
			})
			.subscribe(response => {
				let customer_info = response["data"];

				this.is_retailer = (customer_info && customer_info.is_retailer) ? customer_info.is_retailer : false;

				if (customer_info && !customer_info.is_retailer) {
					if (customer_info.customer) {
						localStorage.setItem('is_retailer', customer_info.is_retailer)
						this.is_retailer = customer_info.is_retailer
						this.addOrderService.postData.customer_id =
							customer_info.customer.customer_id;
						this.addOrderService.postData.mobile_no =
							customer_info.customer.mobile_no;
						this.addOrderService.postData.first_name =
							customer_info.customer.first_name;
						this.addOrderService.postData.last_name =
							customer_info.customer.last_name;
						this.addOrderService.postData.father_first_name =
							customer_info.customer.father_first_name;
						this.addOrderService.postData.father_last_name =
							customer_info.customer.father_last_name;
						this.addOrderService.postData.alternate_mobile_no =
							customer_info.customer.alternate_mobile_no;

						if (customer_info.customer.address) {
							// Address info
							this.addOrderService.postData.address_line_1 =
								customer_info.customer.address.address_line_1;
							this.addOrderService.postData.district =
								customer_info.customer.address.district;

							this.addOrderService.postData.pincode =
								customer_info.customer.address.pincode;
							this.addOrderService.postData.state =
								customer_info.customer.address.state;
							this.addOrderService.postData.tehsil =
								customer_info.customer.address.tehsil;

							this.addOrderService.postData.village =
								customer_info.customer.address.village;
						}

						if (this.addOrderService.postData.state) {
							// Make API call to store respective listing for address
							this.collectAddresses(
								"state",
								this.addOrderService.postData.state
							);
						}

						if (this.addOrderService.postData.district) {
							// Make API call to store respective listing for address
							this.collectAddresses(
								"district",
								this.addOrderService.postData.district
							);
						}

						if (this.addOrderService.postData.tehsil) {
							// Make API call to store respective listing for address
							this.collectAddresses(
								"tehsil",
								this.addOrderService.postData.tehsil
							);
						}

						this.checkForCartData();
					}

					this.getFarmsData(
						this.addOrderService.postData.customer_id
					);

					if (customer_info.customer_details) {
						this.addOrderService.postData.customer_details = JSON.parse(
							customer_info.customer_details.customer_details
						);

						if (
							this.addOrderService.postData.customer_details ==
							null
						) {
							this.addOrderService.postData.customer_details = {
								irrigation_details: "",
								total_area: "",
								crops: [],
								farmer_type: "",
								mobile_type: "smart",
								equipments: [],
								use_whatsapp: "yes",
								comments: "",
								whataspp_no_same: "yes",
								sms_alert: "yes",
								customer_id: "",
								add_on_whatsapp: "yes"
							};
						}
					}
				} else {
					this.addOrderService.reassignData();

					if (customer_info && customer_info.retailer_data) {
						this.addOrderService.postData.first_name =
							customer_info.retailer_data.first_name;

						this.addOrderService.postData.last_name =
							customer_info.retailer_data.last_name;

						this.addOrderService.postData.father_first_name = '';
						this.addOrderService.postData.father_last_name = '';
					}

				}

			});
	}

	checkForCartData() {
		this.apiService
			.post("orders/get-cart", {
				customer_id: this.addOrderService.postData.customer_id
			})
			.subscribe(response => {
				if (response["data"].length > 0) {
					this.addOrderService.hascartinfo = true;
					this.addOrderService.postData.place_order = "yes";
					this.addOrderService.postData.cart_action_date =
						response["data"][0].action_date;

					this.getProducts(response["data"]);
				}
			});
	}

	getProducts(all_cart) {
		this.apiService
			.post("products/get-products", {})
			.subscribe(response => {

				response["data"]["data"].forEach(function(item) {
					item.product_selling_price = item.selling_price;
				});

				let all_products = response["data"];
				this.bindFurtherOrderData(all_products, all_cart);
			});
	}

	getTheArrIndexByKey(data, id) {
		if (data.length === 0) {
			return null;
		}
		var keepGoing = true;
		var keyVal = null;

		let i = 0;

		for (i = 0; i < data.length; i++) {
			if (keepGoing) {
				if (data[i]["product_id"] === id) {
					keyVal = i;
					keepGoing = false;
				}
			}
		}

		return keyVal;
	}

	bindFurtherOrderData(all_products, all_cart) {
		var total_price = 0;

		this.addOrderService.pre_projects = [];

		all_cart.forEach(innerorder => {

			let productIndex = this.getTheArrIndexByKey(
				all_products,
				innerorder.product_id
			);

			if (productIndex != null) {

				let product = all_products[productIndex];

				let pre_product: any = {};

				pre_product.id = this.addOrderService.pre_projects.length + 1;
				pre_product.product_name = product.product_name;
				pre_product.product_id = product.product_id;

				pre_product.quantity = innerorder.quantity;
				pre_product.discount = innerorder.discount;

				pre_product.product = product;
				pre_product.product_sku = product.product_sku;

				pre_product.price = product.product_selling_price;

				pre_product.total = pre_product.price - pre_product.discount;
				pre_product.total = pre_product.total * innerorder.quantity;

				this.addOrderService.pre_projects.push(pre_product);

				total_price += pre_product.total;

			}
		});

		this.addOrderService.orderData.grand_total = total_price;
		this.addOrderService.orderData.sub_total = total_price;
		this.addOrderService.orderData.additional_discount = 0;
		this.addOrderService.orderData.total_additional_discount = 0;
	}

	getFarmsData(customer_id) {
		this.apiService
			.post("farm/get-farms", {
				customer_id: customer_id
			})
			.subscribe(response => {
				var results = response["data"];

				if (results && results.length > 0) {
					this.addOrderService.postData.farms = [];

					for (let i = 0; i < results.length; i++) {
						this.addOrderService.postData.farms.push({
							field_name: results[i].field_name,
							farm_id: results[i].id,
							crop_id: results[i].category_id,
							crop_name: results[i].category_name,
							area: results[i].area,
							unit: results[i].unit_id,
							crop_sowing_date: results[i].crop_sowing_date
						});
					}
				}
			});
	}

	collectAddresses(type_address, value) {
		let addressInfo: any = {};

		if (type_address === "state") {
			addressInfo.state_name = value;
			addressInfo.searchon = "district_name";
		}

		if (type_address === "district") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.searchon = "tehsil_name";
		}

		if (type_address === "tehsil") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.tehsil_name = this.addOrderService.postData.tehsil;
			addressInfo.searchon = "village_name";
		}

		this.apiService
			.post("customer/address/info", addressInfo, null, false)
			.subscribe(result => {
				if (type_address === "state") {
					this.addOrderService.all_district = result["data"];
				}

				if (type_address === "district") {
					this.addOrderService.all_tehsil = result["data"];
				}

				if (type_address === "tehsil") {
					this.addOrderService.all_village = result["data"];
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/pages/addorder/customer/customer.ts